const logger_worker = new (require('../msysLogger/logger_worker.js'))()
module.exports = logger_worker

console.debug_orig = console.debug2 = console.debug
console.log_orig = console.log2 = console.log
console.info_orig = console.info2 = console.info
console.warn_orig = console.warn2 = console.warn
console.error_orig = console.error2 = console.error
console.logger_worker = logger_worker

const stdout = typeof process === 'object' && typeof process.stdout === 'object' ? process.stdout : null

logger_worker.debug = function(sender, text, dt, level) {
  try{
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target: 'msysLogger', action: 'mmDebug', params: { level, text } })
  }catch(e) {}
}
logger_worker.log = function(sender, text, dt) {
  try{
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target: 'msysLogger', action: 'mmDebug', params: { text } })
  }catch(e) {}
}
logger_worker.info = function(sender, text, dt) {
  try{
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target: 'msysLogger', action: 'mmInfo', params: { text } })
  }catch(e) {}
}
logger_worker.warn = function(sender, text, dt) {
  try{
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target: 'msysLogger', action: 'mmWarning', params: { text } })
  }catch(e) {}
}
logger_worker.error = function(sender, text, dt) {
  try{
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target: 'msysLogger', action: 'mmError', params: { text } })
  }catch(e) {}
}
logger_worker.message = function(sender, target, action, params, dt) {
  try{
    if(action==='mmH264' && typeof params.payload !== 'string') params = { ...params, payload: new Uint8Array(0) }
    logger_worker.postMessage({ dt: dt||unow(), cols: stdout?.columns, sender, target, action, params })
  }catch(e) {
    if(/object could not be cloned/.test(e.message) && typeof (window)!=='undefined') {
      // we cannot send DOM objects to worker, try to clean up DOM parameters
      const params2 = {}
      for(const p in params) {
        if(params[p] instanceof Document || params[p] instanceof Element) params2[p] = {}
        else params2[p] = params[p]
      }
      try{
        logger_worker.postMessage({ dt, cols: stdout?.columns, type: 'message', sender, target, action, params2 })
      }catch(e) {
        console.error_orig(e)
      }
    }else{
      console.error_orig(e)
    }
  }
}

console.debug = function(...args) {
  logger_worker.debug('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.log = function(...args) {
  logger_worker.log('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.info = function(...args) {
  logger_worker.info('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.warn = function(...args) {
  logger_worker.warn('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.error = function(...args) {
  logger_worker.error('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}

logger_worker.info('system', 'STARTING APPLICATION '+MOSY_APP_WITH_VERSION, MOSY_PROCESS_START_US)
logger_worker.debug('system', 'STARTING SCRIPT', MOSY_SCRIPT_START_US)
